import { createSelector } from 'reselect';
import { getTrolley } from './get-items';

export default createSelector(getTrolley, ({ loadingCustomerInfo }) => loadingCustomerInfo);
